import {
  toCamelCase as stringToCamelCase,
  toUnderscores as stringToUnderscores
} from './string';

const recursivelyReplaceProps = replace => function replaceProps(target) {
  const isPrimitive =
    typeof target === 'number' ||
    typeof target === 'string' ||
    typeof target === 'boolean';

  if (!target || isPrimitive) {
    return target;
  }

  if (Array.isArray(target)) return target.map(replaceProps);
  return Object.keys(target).reduce((result, key) => ({
    ...result,
    [replace(key)]: replaceProps(target[key])
  }), {});
};

export const values = object => Object.keys(object).map(key => object[key]);

export const omit = (keys, object) => Object.keys(object).reduce((result, key) => (
  keys.includes(key) ? result : { ...result, [key]: object[key] }
), {});

export const pick = (items = [], target = {}) => items.reduce((picked, key) => (
  target[key] ? { ...picked, [key]: target[key] } : picked
), {});

export const toCamelCase = recursivelyReplaceProps(stringToCamelCase);

export const toUnderscores = recursivelyReplaceProps(stringToUnderscores);

export const notUndefined = object => Object.keys(object).reduce((result, key) => (
  object[key] === undefined ? result : { ...result, [key]: object[key] }
), {});

export const invert = obj => Object.keys(obj).reduce((inverted, key) => ({
  ...inverted,
  [obj[key]]: key
}
), {});



// WEBPACK FOOTER //
// ./src/universal/ui/utils/object.js